<template>
  <div>
    <div v-if="!$store.getters.token">
      <!-- 登入-桌機彈窗 -->
      <div v-if="$store.state.user.isLoginActive" class="popup-wrap register-wrap" :class="{ active: $store.state.user.isLoginActive }">
        <div class="popup-box popup-box-md fullScreen-md">
          <a class="popup-close" @click="deactivatePopup"><i class="fa-solid fa-xmark" /></a>
          <div class="form-popup popup-padding m-loginRegister-frame">
            <form class="row-frame dep-form-frame colu-12 reg-popupBox">
              <h4 class="register-title font-w-b text-align-L">
                {{ $t("Bao.login_play") }}
              </h4>
              <div class="login-option-frame">
                <div
                  class="colu-auto btn select-user"
                  :class="{ 'active': (loginType === 'username') }"
                  @click="switchLoginType('username')"
                >
                  <i class="icon-user-solid">
                    <img :src="$getThemeImagePath('icon-member.png')" alt="">
                  </i>
                  <i class="icon-user-light-solid">
                    <img :src="$getThemeImagePath('icon-member-active.png')" alt="">
                  </i>
                  {{ $t("Bao.username") }}
                </div>
                <div
                  class="colu-auto btn select-mobile"
                  :class="{ 'active': (loginType === 'phone') }"
                  @click="switchLoginType('phone')"
                >
                  <i class="icon-mobile-solid">
                    <img :src="$getThemeImagePath('icon-phone.png')" alt="">
                  </i>
                  <i class="icon-mobile-light-solid">
                    <img :src="$getThemeImagePath('icon-phone-active.png')" alt="">
                  </i>
                  {{ $t("Bao.phone") }}
                </div>
              </div>
              <div :class="{'login-user-container': loginType === 'username', 'login-mobile-container': loginType === 'phone'}">
                <div class="reg-form-area">
                  <!--帳號登入-->
                  <div v-show="loginType === 'username'" class="colu colu-auto">
                    <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="username">
                      <i class="icon-user-solid">
                        <img :src="$getThemeImagePath('icon-account.png')" alt="">
                      </i>
                      {{ $t("Bao.username") }}
                    </label>
                    <div class="colu-sm-12 colu-md-8 colu-12">
                      <input
                        v-model="username"
                        v-validate="'required'"
                        class="colu-12 for-input inpType"
                        :class="{ 'isInvalid': errors.has('username') && loginType === 'username'}"
                        :placeholder="$t('Bao.username_require')"
                        type="text"
                        name="username"
                        :data-vv-as="$t('Bao.username')"
                        autocomplete="off"
                      >
                    </div>
                    <div v-if="errors.has('username') && loginType === 'username'" class="input-feedback text-align-R">
                      {{ $t("Bao.user_name_error") }}
                    </div>
                  </div>
                  <!--手機號碼登入-->
                  <div v-show="loginType === 'phone'" class="colu colu-auto">
                    <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="username">
                      <i class="icon-mobile-solid ">
                        <img :src="$getThemeImagePath('icon-phone.png')" alt="">
                      </i>
                      {{ $t("Bao.phone") }}
                    </label>
                    <div class="colu-sm-12 colu-md-8 colu-12 country-select-frame">
                      <div class="row-frame">
                        <div class="colu-2 country-select-box">
                          <div class="form-select-1 country-select">
                            <div class="form-select-value">
                              <img :src="$getThemeImagePath('japan.png')" alt="">
                            </div>
                          </div>
                        </div>
                        <div class="colu-10 number-box">
                          <input
                            v-model="phone"
                            v-validate="'required'"
                            class="colu-12 for-input inpType"
                            :class="{ 'isInvalid': errors.has('phone') && loginType === 'phone'}"
                            type="text"
                            name="phone"
                            :data-vv-as="$t('Bao.phone')"
                            autocomplete="off"
                            :required="true"
                          >
                        </div>
                      </div>
                    </div>
                    <div v-if="errors.has('phone') && loginType === 'phone'" class="input-feedback text-align-R">
                      {{ $t("Bao.login_phone_error") }}
                    </div>
                  </div>

                  <div class="colu colu-auto">
                    <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="login-mobile-パスワード">
                      <i class="icon-password ">
                        <img :src="$getThemeImagePath('icon-password.png')" alt="">
                      </i>
                      {{ $t("Bao.password") }}
                    </label>
                    <div class="colu-sm-12 colu-md-8 colu-12">
                      <input
                        id="login-mobile-パスワード"
                        v-model="postForm.password"
                        v-validate="'required'"
                        class="colu-12 for-input inpType"
                        :class="{ 'isInvalid': errors.has('password') }"
                        type="password"
                        :placeholder="$t('Bao.password_require')"
                        name="password"
                        :data-vv-as="$t('Bao.password')"
                        data-vv-name="password"
                        autocomplete="current-password"
                      >
                    </div>
                    <div v-if="errors.has('password')" class="input-feedback text-align-R">
                      {{ $t("Bao.new_password_error") }}
                    </div>
                  </div>

                  <div>
                    <div class="lognLinks-frame">
                      <div @click="navigateToRegister">
                        <a class="create-link">{{ $t("Bao.login_create_account") }}</a>
                      </div>
                      <div @click="navigateToForget">
                        <a class="forgot-link">{{ $t("Bao.forget_password") }}</a>
                      </div>
                    </div>

                    <div class="form-button form-ft">
                      <button
                        class="btn-primary goTo-fun-authenLogin"
                        :disabled="isButtonDisabled"
                        type="button"
                        @click.prevent="clickLogin()"
                      >
                        <span>{{ $t("Bao.login") }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- 二次驗證彈窗 -->
      <div v-if="authModal" class="popup-wrap authen-popup-wrap" :class="{ 'active': authModal }">
        <div class="popup-box">
          <div class="popup-container">
            <a class="popup-close" @click="deactivatePopup"><i class="fa-solid fa-xmark" /></a>
            <div class="form-popup popup-padding">
              <form class="row-frame dep-form-frame colu-12 authen-popupBox">
                <h5 class="mb-1">
                  {{ $t("Bao.auth_modal_text_1") }}
                </h5>

                <div class="colu colu-12">
                  <label class="colu-12 authenTitle-babel" for="Google Authenticator-second">{{ $t("Bao.auth_modal_text_2") }}<span class="highlight-red-02">*</span></label>
                </div>

                <div class="colu colu-12 ">
                  <div class="colu-12 inp-relative">
                    <input
                      id="Google Authenticator-second"
                      v-model="authenticatorCode"
                      class="colu-12 for-input inpType inp-float"
                      type="text"
                      :placeholder="$t('Bao.auth_modal_text_2')"
                    >
                    <div class="icon-inpInside icon-authen " />
                  </div>
                </div>

                <div class="bank-promo-n form-submit-frame">
                  <button
                    :disabled="!authenticatorCode || authenticatorCode.length != 6 || actionLoading"
                    class="btn-primary btn-authen btn-mb-w-100"
                    @click.prevent="checkCode"
                  >
                    <span>{{ $t("Bao.auth_modal_text_3") }}</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login, loginUseOptCode } from '@/api/user'
import { login as localLogin } from '@/utils/user'
import { showNotice } from '@/utils/tool'

export default {

  data() {
    const postForm = {
      username: null,
      password: null
    }
    return {
      loginType: 'username', // username, phone
      postForm,
      actionLoading: false,
      previousUsername: '',
      sessionKey: null,
      authModal: false,
      authenticatorCode: null,
      username: null,
      phone: null
    }
  },
  computed: {
    isButtonDisabled() {
      const hasErrors = this.errors.any()

      if (this.loginType === 'username') {
        return hasErrors || !this.username || !this.postForm.password
      } else {
        return hasErrors || !this.phone || !this.postForm.password
      }
    }
  },
  created() {

  },
  methods: {
    switchLoginType(loginType) {
      this.$validator.errors.clear()
      this.$validator.reset()
      this.loginType = loginType
      this.postForm = {}
      this.username = null
      this.phone = null
    },
    formatPhoneNumber(input) {
      if (this.loginType !== 'username') {
        const str = '' + input
        return '+81 ' + str.slice(0, 2) + '-' + str.slice(2, 6) + '-' + str.slice(6)
      }
    },
    deactivatePopup() {
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.authModal = false
    },
    navigateToRegister() {
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.$store.commit('SET_REGISTER_OPEN', true)
    },
    navigateToForget() {
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.$store.commit('SET_FORGET_OPEN', true)
    },
    clickLogin() {
      if (this.loginType === 'phone' && this.phone !== null) {
        this.postForm.username = this.formatPhoneNumber(this.phone)
      } else {
        this.postForm.username = this.username
      }

      const fieldsToValidate = ['passwordz']
      if (this.loginType === 'username') {
        fieldsToValidate.push('username')
      } else if (this.loginType === 'phone') {
        fieldsToValidate.push('phone')
      }

      this.$validator.validateAll(fieldsToValidate).then(valid => {
        if (valid) {
          this.actionLoading = true
          login(this.postForm).then(response => {
            if (response.data.data.code === 1) { // 二次認證，sessionKey帶入後續
              this.$store.commit('SET_LOGIN_OPEN', false)
              this.sessionKey = response.data.data.session_key
              this.authModal = true
              return
            }

            if (response.data.data.code === 0) {
              this.getTokenAndLogin(response) // 不需二次認證，直接登入
            } else {
              showNotice(this.$t('Bao.login_error2'))
            }
          }).catch(error => {
            if (error && error.response) {
              const errorCode = error.response.data.data.code[0]

              let errorMessage = ''
              switch (errorCode) {
                case '1':
                  errorMessage = this.$t('Bao.login_error1', { time: new Date(error.response.data.data.time[0] * 1000).toLocaleString() })
                  break
                case '2':
                  errorMessage = this.$t('Bao.login_error2')
                  break
                case '3':
                  errorMessage = this.$t('Bao.login_error3')
                  break
                case '4':
                  errorMessage = this.$t('Bao.login_error4')
                  break
                case '5':
                  errorMessage = this.$t('Bao.login_error5')
                  break
                default:
                  errorMessage = 'An unknown error occurred. Please try again.'
              }

              showNotice(errorMessage)
            } else {
              console.log(error)
            }
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    },
    getTokenAndLogin(response) {
      const tokenData = response.data.data.token
      const expiredTime = new Date().getTime() + (tokenData.expired_interval * 1000)
      localStorage.setItem('expired_time', expiredTime)
      localStorage.setItem('token', tokenData.token)
      this.$store.commit('SET_LOGIN_TO_EVENT', true)
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.$store.commit('SET_READ_TERMS', false)

      let redirect = ''
      if (localStorage.getItem('redirectAfterLogin')) {
        redirect = this.$store.state.user.dailyItem.link
        localStorage.removeItem('redirectAfterLogin')
        this.$store.commit('SET_DAILY', false)
        this.$store.commit('SET_DAILY_ITEM', null)
        this.$store.commit('SET_LOGIN_TO_EVENT', false)
      } else if (this.$store.getters.inviteCode !== null) {
        redirect = 'user'
      }

      localLogin(response.data.data, redirect)
    },
    checkCode() {
      this.actionLoading = true

      loginUseOptCode({ // 二次驗證，輸入opt
        username: this.postForm.username,
        session_key: this.sessionKey,
        opt_code: this.authenticatorCode
      }).then(response => {
        if (response.data.data.code === 0) { // 登入成功
          this.getTokenAndLogin(response)
          this.authModal = false
          this.authenticatorCode = null
          this.sessionKey = null
        } else {
          showNotice(this.$t('Bao.auth_error_text'))
        }
      }).catch((error) => {
        showNotice(error.response.data.msg)
      }).finally(() => {
        this.actionLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
